import React from 'react'
import AccountsRequests from 'src/app/AccountsRequests/AccountsRequests'
import { SidenavContentType } from 'src/navigation/appLocations'
import { AppRoute } from 'src/navigation/appRoutes'
import { accountsRequestsRouteProps } from 'src/navigation/routeProps'

const AccountsRequestsAppRoute: AppRoute = {
  routeProps: accountsRequestsRouteProps,
  component: <AccountsRequests />,
  subRoutes: [],
  meta: { contentType: SidenavContentType.Main },
}

export default AccountsRequestsAppRoute
